import ParkingAreasPage from "./parkingAreas";

export default ParkingAreasPage;